<template>
    <div v-if="isOldBrowser()" class="banner">
        <div class="con">
            Evtl. unterstützt Ihr Browser nicht alle Features dieser Webseite. Bei Anzeigeproblemen empfehlen wir Chrome oder Firefox zu nutzen.
        </div>
    </div>
</template>
<script>
export default {
    name: "Banner",
    methods: {
        isOldBrowser: function() {
            let userAgent = (
                (navigator && navigator.userAgent) ||
                ""
            ).toLowerCase();
            let safari = userAgent.match(/version\/(\d+).+?safari/) !== null;
            let ie = userAgent.match(/(?:msie |trident.+?; rv:)(\d+)/) !== null;
            return safari || ie;
        },
    },
};
</script>
<style scoped>
.banner {
    position: fixed;
    bottom: 0%;
    width: 100vw;
    padding: 0.5em;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f08700;
}
.con {
    width: 80%;
    padding: 0;
    margin: 0;
}
</style>
